import { render, staticRenderFns } from "./prepare-resource.vue?vue&type=template&id=32fea2c1"
import script from "./prepare-resource.vue?vue&type=script&lang=js"
export * from "./prepare-resource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports